import React, { Component } from 'react';
import { ProductsSearchBox } from '../ProductsSearch/connected/ProductsSearchBox';
import { Grid } from '@material-ui/core';
import RBACCnn from '../Auth/connected/RBACCnn';


class SearchView extends Component {
    render() {
        return (
            <RBACCnn for="Restaurant">
                <Grid container alignContent="center">
                    <Grid item xs={12} sm={12} >
                        <ProductsSearchBox />
                    </Grid>
                </Grid>
            </RBACCnn>
        );
    }
}

export default SearchView;    